// @flow
import {
	WebComponent,
} from 'fg-frontend';
import tippy from 'tippy.js';

export default class Tooltip extends WebComponent {
	didMount() {
		tippy(this.element, {
			arrow: true,
			theme: 'esp',
		});
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources-3dliving/js/components/Tooltip.js